import type { z } from 'zod';

import { OrderLineStopType } from 'src/types/enums';
import { LoadingMethodEnum, OrderLineStopTypeEnum } from 'src/types/shared.types';

import type { ILine } from './price';
import { calculateLinesTotalExclVat } from './price';

export type OrderForValidation = {
  customer: unknown | null;
  loadingMethod: z.infer<typeof LoadingMethodEnum> | null;
  lines: Array<{
    contents: unknown[];
    stops: Array<{ type: z.infer<typeof OrderLineStopTypeEnum> }>;
    sales?: ILine[];
  }>;
};

export function getOrderValidationError(
  order: OrderForValidation | null | undefined,
  options?: { requireSalePrice?: boolean },
): string | undefined {
  if (!order) {
    return 'Opdracht niet gevonden';
  }

  if (!order.lines.length) {
    return 'Geen opdrachten';
  }

  if (!order.customer) {
    return 'Geen klant geselecteerd';
  }

  if (!order.loadingMethod) {
    return 'Geen wijze van belading geselecteerd';
  }

  for (let i = 0; i < order.lines.length; i++) {
    const line = order.lines[i];
    if (!line.contents.length) {
      return `Geen inhoud voor opdracht ${i + 1}`;
    }

    const hasLoad = line.stops.some((s) => s.type === OrderLineStopType.Load);
    const hasUnload = line.stops.some((s) => s.type === OrderLineStopType.Unload);
    if (!hasLoad || !hasUnload) {
      return `Geen laad- of lossen voor opdracht ${i + 1}`;
    }

    if (options?.requireSalePrice) {
      const totalExclVat = calculateLinesTotalExclVat(line.sales ?? []);
      if (isNaN(totalExclVat) || totalExclVat <= 0) {
        return `Verkoopprijs moet groter zijn dan 0 voor opdracht ${i + 1}`;
      }
    }
  }
}
